import React, { useEffect, useContext, useState } from "react";
import queryString from "query-string";
import { navigate } from "hookrouter";

//Context API for User Info
import { InfoContext } from "./../context/InfoContext";

//httpClient
import AuthenticationClient from "./../httpClient/Authentication";

import Intro from './Intro'

const SamlCallback = () => {
  const { info, setInfo } = useContext(InfoContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const parsed = queryString.parse(
      window.location.search + window.location.hash
    );

    if (parsed && parsed.Email) {
      loginUser(parsed.Email);
    }
  }, []);

  const loginUser = (email) => {
    setLoading(true);
    AuthenticationClient.loginOktaUser(email)
      .then((data) => {
        setLoading(false);
        setInfo(data.userRecord);
        navigate("/dashboard");
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(err.response.data.Message);
      });
  };

  return (
    <Intro error={errorMessage} loadingProp={loading} />
  );
};

export default SamlCallback;